import {
  initCommonHeaderWaffle,
  initCommonHeaderProfile,
  revealLegacyTrailing,
  isLikelyAnonymous
} from './common-header-waffle'

const WAFFLE_SELECTOR = '[data-zoom-waffle-menu]'
const PROFILE_SELECTOR = '[data-zoom-profile-menu]'
const MARKET_VERIFY_SELECTOR = '#market-verify'
const DESKTOP_MEDIA_QUERY = '(min-width: 1025px)'
let lastAuthenticated
let viewportListenerBound = false

// Single auth signal emitted by NavigationWorkplace.js once marketVerify
// resolves (success or error). detail = { authenticated: boolean }.
export const AUTH_RESOLVED_EVENT = 'zoom:auth-resolved'

// Make the choice one time: logged in -> new SDK menus, not logged in -> old menu.
const decide = (authenticated) => {
  lastAuthenticated = Boolean(authenticated)

  if (!window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
    revealLegacyTrailing()
    return
  }

  if (authenticated) {
    // User is logged in: load and show the new Zoom waffle + profile menus.
    initCommonHeaderWaffle()
    initCommonHeaderProfile()
  } else {
    // User is not logged in: just show the old simple menu.
    revealLegacyTrailing()
  }
}

const bindViewportListener = () => {
  if (viewportListenerBound) return
  viewportListenerBound = true

  const desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY)
  const onViewportChange = () => {
    if (typeof lastAuthenticated === 'boolean') {
      decide(lastAuthenticated)
    }
  }

  if (typeof desktopMediaQuery.addEventListener === 'function') {
    desktopMediaQuery.addEventListener('change', onViewportChange)
  } else if (typeof desktopMediaQuery.addListener === 'function') {
    desktopMediaQuery.addListener(onViewportChange)
  }
}

export const initCommonHeaderMenus = () => {
  const hasSdkMarkup =
    document.querySelector(WAFFLE_SELECTOR) || document.querySelector(PROFILE_SELECTOR)
  if (!hasSdkMarkup) return

  bindViewportListener()

  const resolved = window.zoomAuthResolved
  if (resolved && typeof resolved.authenticated === 'boolean') {
    decide(resolved.authenticated)
    return
  }

  let handled = false
  const onResolved = (event) => {
    if (handled) return
    handled = true
    decide(Boolean(event?.detail?.authenticated))
  }
  document.addEventListener(AUTH_RESOLVED_EVENT, onResolved, { once: true })

  if (!document.querySelector(MARKET_VERIFY_SELECTOR) && !handled) {
    handled = true
    document.removeEventListener(AUTH_RESOLVED_EVENT, onResolved)
    decide(!isLikelyAnonymous())
  }
}
